const config = window.config || {};

export const APP_ENDPOINT = config.appEndpoint || 'https://app.teleretro.com';
export const STRIPE_PK = config.stripePk || '';
export const SENTRY_DSN = config.sentryDsn || '';
export const GIPHY_KEY = config.giphyKey || '';
export const KLIPY_KEY = config.klipyKey || '';
export const TENOR_KEY = config.tenorKey || '';
export const ENABLE_ZAP_MANAGER = config.enableZapManager;
